import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useHref } from 'react-router-dom'

// "Watch Now" link: left click keeps the existing in-app navigation,
// right click shows a menu with "Watch in new tab" which opens the video and autoplays it.
function WatchNowLink({ mappingId, onWatch, children, style }) {
    const [menuPos, setMenuPos] = useState(null)
    const href = useHref(`/video/:${mappingId}?autoplay=1`)

    useEffect(() => {
        if (!menuPos) return
        const close = () => setMenuPos(null)
        const onKey = (e) => { if (e.key === 'Escape') close() }
        window.addEventListener('click', close)
        window.addEventListener('scroll', close, true)
        window.addEventListener('resize', close)
        window.addEventListener('keydown', onKey)
        return () => {
            window.removeEventListener('click', close)
            window.removeEventListener('scroll', close, true)
            window.removeEventListener('resize', close)
            window.removeEventListener('keydown', onKey)
        }
    }, [menuPos])

    const handleClick = (e) => {
        // let ctrl/cmd/shift/middle click use the browser's default (new tab/window)
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return
        e.preventDefault()
        onWatch()
    }

    const handleContextMenu = (e) => {
        if (!mappingId) return
        e.preventDefault()
        e.stopPropagation()
        setMenuPos({ x: e.clientX, y: e.clientY })
    }

    const openInNewTab = (e) => {
        e.stopPropagation()
        setMenuPos(null)
        window.open(href, '_blank', 'noopener')
    }

    return (
        <>
            <a
                href={mappingId ? href : undefined}
                style={{ color: '#18A0FB', cursor: 'pointer', ...style }}
                onClick={handleClick}
                onContextMenu={handleContextMenu}
            >
                {children}
            </a>
            {menuPos && createPortal(
                <div
                    style={{
                        position: 'fixed',
                        top: Math.min(menuPos.y, window.innerHeight - 50),
                        left: Math.min(menuPos.x, window.innerWidth - 190),
                        zIndex: 10000,
                        background: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: 6,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        padding: 4,
                        minWidth: 180,
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onContextMenu={(e) => e.preventDefault()}
                >
                    <div
                        role='menuitem'
                        onClick={openInNewTab}
                        className='hover:bg-gray-100'
                        style={{ padding: '8px 12px', cursor: 'pointer', borderRadius: 4, fontSize: 14, color: '#333' }}
                    >
                        <i className='fa-solid fa-up-right-from-square me-2'></i>
                        Watch in new tab
                    </div>
                </div>,
                document.body
            )}
        </>
    )
}

export default WatchNowLink
